import { AxiosResponse } from 'axios';
import { IReportsResponse } from '../types';
import settings from '../settings';
import api from './base';

export function getReports(params: { page?: number; limit?: number } = {}): Promise<AxiosResponse<IReportsResponse>> {
  const uri = `${settings.getApiURI()}/report/v1/reports`;

  return api.http.get(uri, {
    params: {
      type: '',
      q: '',
      page: 1,
      limit: 9,
      ...params,
    },
  });
}

export function getStoryReports(params: { q: string; page?: number; limit?: number }) {
  const uri = `${settings.getApiURI()}/story/v1/stories/${params.q}/reports`;

  return api.http.get(uri, {
    params: {
      page: 1,
      limit: 9,
      ...params,
    },
  });
}

export function updateReportStatus(id: number, status: 'open' | 'resolved' | 'dismissed') {
  const uri = `${settings.getApiURI()}/report/v1/reports/${id}`;
  return api.http.post(uri, { status });
}

export function updateMultipleReportStatus(ids: number[], status: 'open' | 'resolved' | 'dismissed') {
  const uri = `${settings.getApiURI()}/report/v1/reports`;
  return api.http.post(uri, { ids, status });
}
